<template>
  <div>
    <div class="caption round-medium shadow-huge card left-text">
        <router-link class="d-block" :to="link">
          <img v-bind:src="'images/mpower-new/'+image" class="caption-image ">
        </router-link>
        <!-- <h5 class="color-white uppercase ultrabold bottom-10"></h5>
        <img v-bind:src="'images/mpower/'+image" class="caption-image owl-lazy"> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliderHighlight',
  props: {
    image: String,
    link: String,
    back: String,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.owl-carousel .owl-item img {
    max-width: 500px;
}
</style>
